import * as ActionTypes from '../../actions/ActionTypes';
import KnowledgeBaseRecord from '../records/KnowledgeBaseRecord';
import KnowledgeBaseDetailsRecord from '../records/KnowledgeBaseDetailsRecord';
import { findKnowledgeBaseByIdOrGetDefault } from '../utils/findKnowledgeBaseByIdOrGetDefault';
import { FetchStatus } from '../data/KnowledgeBaseDetails';
export default function knowledgeBaseDetails(state = new KnowledgeBaseDetailsRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_KNOWLEDGE_BASE_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined,
        status: FetchStatus.PENDING
      });
    case ActionTypes.FETCH_KNOWLEDGE_BASE_SUCCESS:
      {
        const {
          knowledgeBases,
          requestedKnowledgeBaseId
        } = action.payload;
        const knowledgeBase = findKnowledgeBaseByIdOrGetDefault(knowledgeBases.objects, requestedKnowledgeBaseId);
        return state.merge({
          isRequesting: false,
          knowledgeBase: knowledgeBase ? new KnowledgeBaseRecord(knowledgeBase || {}) : undefined,
          lastLoaded: new Date().valueOf(),
          error: undefined,
          status: FetchStatus.SUCCEEDED
        });
      }
    case ActionTypes.FETCH_KNOWLEDGE_BASE_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error,
        status: FetchStatus.ERROR
      });
    case ActionTypes.UPDATE_KNOWLEDGE_BASE_SUCCESS:
      return state.merge({
        knowledgeBase: new KnowledgeBaseRecord(action.payload)
      });
    default:
      return state;
  }
}